import React from 'react'
import { Task } from '@core/entities/task/Task'
import { Flex } from '@fundamentals'
import { TaskRequestApproveChangesCard } from '@modules/tasks/taskDetails/components/TaskRequestApproveChangesCard'
import { TaskPeopleCard } from './components/TaskPeopleCard'
import { TaskInspectionCard } from './components/TaskInspectionCard'
import { LinkedChecklistResult } from '@core/entities/linkedProcesses'
import { TemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'

type TaskDetailsSidebarProps = {
  task: Task
  checklist?: LinkedChecklistResult
  answer?: TemplateQuestionGroup
}

export const TaskDetailsSidebar: React.FC<TaskDetailsSidebarProps> = ({
  task,
  checklist,
  answer,
}) => {
  return (
    <Flex flexDirection='column' gap={2}>
      {(task?.isAwaitingApproval() || task?.hasRequestedChanges()) && (
        <TaskRequestApproveChangesCard task={task} />
      )}

      <TaskPeopleCard task={task} />

      {checklist && (
        <TaskInspectionCard
          checklistQuestionGroup={answer}
          checklist={checklist}
        />
      )}
    </Flex>
  )
}
